import React, { useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import db, { auth } from "../firebase";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/userSlice";

import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import styled from "@emotion/styled";

function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const history = useHistory();

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        db.collection("users")
          .doc(user.uid)
          .get()
          .then((doc) => {
            let data = doc.data();
            dispatch(
              userActions.userLogin({
                name: data.name,
                email: data.email,
                userId: user.uid,
              })
            );
          });
      }
    });
  }, []);

  const userLogOut = () => {
    dispatch(userActions.userLogOut());
    auth.signOut();
    onClose();
    history.replace("/home");
  };

  return (
    <Nav>
      <img src="/images/logo.png" alt="My Logo" />
      <Controllers>
        <div>
          <Link to="/home">Home</Link>
        </div>
        <div>
          <Link to="/browse">Explore</Link>
        </div>
        {!user.name ? (
          <div>
            <Link to="/signup">Become a host</Link>
          </div>
        ) : (
          <div>
            <Link to="/property/addproperty">Post my property</Link>
          </div>
        )}

        <div>
          {!user.name ? (
            <Link to="/signup">
              <Button
                color="white"
                bgColor="#EE575D"
                _hover={{ color: "#EE575D", bgColor: "#EDF2F7" }}
              >
                Sign Up
              </Button>
            </Link>
          ) : (
            <span>
              <strong>Welcome back!,</strong> {user.name}
            </span>
          )}
        </div>
        <div>
          {!user.name ? (
            <Link to="/signin">
              <Button _hover={{ color: "#EE575D" }}>Sign In</Button>
            </Link>
          ) : (
            <Link to="/home">
              <Button _hover={{ color: "#EE575D" }} onClick={userLogOut}>
                Sign Out
              </Button>
            </Link>
          )}
        </div>
      </Controllers>
      <ButtonHamburger ref={btnRef} color="#EE575D" onClick={onOpen}>
        <HamburgerIcon />
      </ButtonHamburger>

      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Welcome, {user.name} !</DrawerHeader>

          <DrawerBodyFlex>
            <div>
              <Link onClick={onClose} to="/">
                Home
              </Link>
            </div>
            <div>
              <Link onClick={onClose} to="/browse">
                Explore
              </Link>
            </div>
            {!user.name ? (
              <div>
                <Link to="/signup">Become a host</Link>
              </div>
            ) : (
              <div>
                <Link to="/property/addproperty">Post my property</Link>
              </div>
            )}
            <div>
              {!user.name && (
                <Link to="/signup">
                  <Button
                    onClick={onClose}
                    color="white"
                    bgColor="#EE575D"
                    _hover={{ color: "#EE575D", bgColor: "#EDF2F7" }}
                  >
                    Sign Up
                  </Button>
                </Link>
              )}
              {!user.name ? (
                <Link to="/signin">
                  <Button onClick={onClose} _hover={{ color: "#EE575D" }}>
                    Sign In
                  </Button>
                </Link>
              ) : (
                <Button onClick={userLogOut} _hover={{ color: "#EE575D" }}>
                  Sign Out
                </Button>
              )}
            </div>
          </DrawerBodyFlex>
        </DrawerContent>
      </Drawer>
    </Nav>
  );
}

export default Header;

const Nav = styled.div`
  width: 100vw;
  height: 80px;
  z-index: 100;
  padding: 35px;
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: white;

  box-shadow: 5px 4px 19px -17px #000000;

  align-items: center;
  justify-content: space-between;
  color: black;

  span {
    margin-right: 10px;
  }

  img {
    flex-shrink: 0;
    width: 100px;
    margin-left: -15px;
  }
`;

const Controllers = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  a {
    margin: 0px 25px;
    text-decoration: none;
    outline: none;
    transition: all 250ms;

    &:hover {
      color: #ee575d;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const DrawerBodyFlex = styled(DrawerBody)`
  display: flex;
  flex-direction: column;

  div {
    margin: 15px 0px;
  }

  button {
    margin-right: 20px;
  }
`;

const ButtonHamburger = styled(Button)`
  @media (min-width: 768px) {
    display: none;
  }
`;
